<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> خودروهای اسقاطی </span>

    </div>

</div>

<main style="direction: rtl;" class="px-2">

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2">

            <div class="col-12 col-md-11">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 d-flex align-items-end px-md-1 col-md-1">

                <button class="btn btn-success w-100" (click)="openScrap_Modal()"> افزودن </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 123px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
                
                    <tr class="">
        
                        <th class="text-center"> # </th>

                        <th class="text-center"> عملیات </th>
            
                        <th class="text-center"> تاریخ اسقاط  </th>

                        <th class="text-center"> شماره شاسی </th>

                        <th class="text-center"> شماره موتور  </th>

                        <th class="text-center"> شماره بدنه  </th>

                        <th class="text-center"> سال ساخت  </th>

                        <th class="text-center"> نوع </th>

                        <th class="text-center"> نام </th>

                        <th class="text-center"> تیپ </th>

                        <th class="text-center"> رنگ </th>

                        <th class="text-center"> تعداد سیلندر </th>

                        <th class="text-center"> تعداد محور </th>

                        <th class="text-center"> تعداد چرخ </th>

                        <th class="text-center"> نوع سوخت </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Scrap_Cars;let i = index">

                        <th> {{ i + 1 | faNum }} </th>
                        
                        <td class="pointer"> 
                            
                            <i class="fa fa-edit fa-lg text-primary" (click)="openScrap_Modal(item,i)" title="ویرایش"></i> 

                            <i class="fa fa-trash fa-lg text-danger mx-2" (click)="remove_Scrap(item,i)" title="حذف"></i> 
                        
                        </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strChassisNumber | faNum }} </td>

                        <td> {{ item.strEngineNumber | faNum }} </td>

                        <td> {{ item.strVIN | faNum }} </td>

                        <td> {{ item.iYearConstruction | faNum }} </td>

                        <td> {{ item.strMobileType_strComment | faNum }} </td>

                        <td> {{ item.strGPSType_strComment | faNum }} </td>

                        <td> {{ item.strVehicleType | faNum }} </td>

                        <td> {{ item.strColor | faNum }} </td>

                        <td> {{ item.tiCylinders | faNum }} </td>

                        <td> {{ item.tiAxis | faNum }} </td>

                        <td> {{ item.tiWheels | faNum }} </td>

                        <td> {{ item.tiFuelType | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="Scrap_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش اطلاعات' : 'افزودن خودرو اسقاطی' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Scrap" class="container-fluid row gx-2 gy-2 p-2">

                    <!-- شماره شناسایی خودرو -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *شماره شناسایی خودرو </label>
            
                        <input formControlName="strUnitID" class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد سیلندر -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد سیلندر </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="tiCylinders" class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد محور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد محور </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="tiAxis" class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد چرخ -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد چرخ </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="tiWheels" class="form-control p-2 text-center">
            
                    </div>

                    <!-- شماره موتور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *شماره موتور </label>
            
                        <input formControlName="strEngineNumber" class="form-control p-2 text-center">
            
                    </div>

                    <!-- شماره شاسی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *شماره شاسی </label>
            
                        <input formControlName="strChassisNumber" class="form-control p-2 text-center">
            
                    </div>

                    <!-- حجم سیلندر -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> حجم سیلندر </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="iCylinderVolume" class="form-control p-2 text-center">
            
                    </div>

                    <!-- نوع سوخت -->

                    <div class="col-12 col-md-3 position-relative p-2">

                        <label class="mb-2 text-muted"> نوع سوخت </label>
            
                        <select class="form-select" formControlName="tiFuelType">
            
                            <option class="text-center" [value]="0"> ندارد</option>
            
                            <option class="text-center" [value]="1"> بنزین </option>
            
                            <option class="text-center" [value]="2"> نفت گاز </option>
            
                            <option class="text-center" [value]="3"> هیبرید </option>
            
                            <option class="text-center" [value]="4"> برقی </option>
            
                        </select>
            
                    </div>

                    <!-- تیپ خودرو -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تیپ خودرو </label>
            
                        <input formControlName="strVehicleType" class="form-control p-2 text-center">
            
                    </div>

                    <!-- نوع خودرو -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *نوع خودرو </label>
            
                        <select class="form-select" formControlName="tiMobileType">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>
            
                            <option class="text-center" *ngFor="let item of carWork" value="{{item.tiMobileType}}">
            
                                {{item.strComment}}
            
                            </option>
            
                        </select>
            
                    </div>

                    <!-- نام خودرو -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *نام خودرو </label>
            
                        <custom-filter *ngIf="showFilter"

                            [strValue]="returnStrValue('tiGPSType',mdl_Scrap.get('tiGPSType')?.value,carType,'strComment')"
                    
                            [strComment]="'strComment'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: center']"
                    
                            [str_Placeholder]="''"
                    
                            [lst_Main]="carType" 
                    
                            [lst_SearchKey]="['strComment']"
                    
                            [isDisabled]="false"
                            
                            (hideOptions)="mdl_Scrap.get('tiGPSType')?.setValue($event?.tiGPSType ? $event.tiGPSType : '')">
            
                        </custom-filter>
            
                    </div>

                    <!-- سال ساخت -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *سال ساخت </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="iYearConstruction" class="form-control p-2 text-center">
            
                    </div>

                    <!-- رنگ خودرو -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> رنگ خودرو </label>
            
                        <input formControlName="strColor" class="form-control p-2 text-center">
            
                    </div>

                    <!-- VIN خودرو -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *VIN خودرو </label>
            
                        <input formControlName="strVIN" class="form-control p-2 text-center">
            
                    </div>

                    <!-- تاریخ اسقاط -->
            
                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> *تاریخ اسقاط </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input type="text" formControlName="strDate" class="form-control text-end" />
            
                        </ng-persian-datepicker>
            
                    </div>
            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " class="btn" (click)="submit_Scrap()">

                    &nbsp; &nbsp; 
                    
                    {{bEditMode ? 'ویرایش' : 'ثبت' }}
                    
                    &nbsp; &nbsp;

                </button>


                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>